/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class PageTemplatesRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    return hash({
      pages: this.store.findAll('posts/page'),
      tagCategories: this.store.findAll('posts/tag-category'),
      assessments: this.store.query('assessments/assessment', {
        isPublished: true,
      }),
      assessmentCategories: this.store.findAll('assessments/category'),
      goalSubjects: this.store.findAll('goals/subject'),
      schoolGroups: this.store.findAll('schools/group'),
      usageSets: this.store.findAll('schools/usage-set'),
      schools: this.store.findAll('school'),
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
